/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import "./Footer.scss";
export default function DemoFooter() {
  return (

    <body className="d-flex flex-column">
    <footer id="sticky-footer" className="py-4" style = {{fontFamily: 'Barlow' , color : 'white', backgroundColor :'black' }}>
      <div className="container text-center">
        <small>Copyright &copy; SIDDHRTH MISHRA</small>
        <br/>
        <a className="fa fa-envelope fa-2x m-4"  href="mailto:siddharthm1999@outlook.com"></a>
        <a className="fa fa-instagram fa-2x m-4"  href="https://www.instagram.com/Im_sidm9/"></a>
        <a className="fa fa-github fa-2x  m-4"  href="https://github.com/Sidm9/"></a>
        <a className="fa fa-linkedin fa-2x  m-4" href = "https://in.linkedin.com/in/siddharth-mishra-56273b172"></a>
      </div>

    </footer>
  </body>

  );
}
